import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import NoDataMessage from "./NoDataMessage";
import { CSVLink } from "react-csv";
import "./Dashboard.css";

const FilteredView = ({ type }) => {
  const [devices, setDevices] = useState([]);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetch("/api/devices")
      .then((res) => res.json())
      .then((data) => setDevices(data))
      .catch((err) => console.error("Failed to load devices", err));

    fetch("/api/settings")
      .then((res) => res.json())
      .then((data) => setSettings(data))
      .catch((err) => console.error("Failed to load settings", err));
  }, []);

  const minVoltage = settings.voltageThresholds?.below ?? 108;
const maxVoltage = settings.voltageThresholds?.above ?? 132;

  const filterDevices = () => {
    switch (type) {
      case "online":
        return devices.filter((d) => d.status === "online");
      case "offline":
        return devices.filter((d) => d.status === "offline");
      case "outages":
        return devices.filter((d) => d.status === "outage");
      case "alerts":
        return devices.filter(
          (d) =>
            (d.voltageL1 && (d.voltageL1 < minVoltage || d.voltageL1 > maxVoltage)) ||
            (d.voltageL2 && (d.voltageL2 < minVoltage || d.voltageL2 > maxVoltage))
        );
      case "blinks":
        return devices.filter((d) => d.blinks && d.blinks.length > 0);
      default:
        return [];
    }
  };

  const filtered = filterDevices();

  const exportData = filtered.map((d) => ({
    DeviceID: d.deviceId,
    MeterNumber: d.meterNumber || "-",
    Address: d.address || "-",
    Voltage_L1: d.voltageL1 || "-",
    Voltage_L2: d.voltageL2 || "-",
    Voltage_LL: d.voltageLL || "-",
    Battery: d.battery || "-",
    GPS_Lat: d.lat || "-",
    GPS_Lon: d.lon || "-",
    LastSeen: d.lastSeen ? new Date(d.lastSeen).toLocaleString() : "-",
  }));

  return (
    <div style={{ display: "flex", background: "#eee", minHeight: "100vh", position: "relative" }}>
      <Sidebar />
      <div style={{ flex: 1, padding: "2rem" }}>
        <h2>
          {type === "online"
            ? "Online Devices"
            : type === "offline"
            ? "Offline Devices"
            : type === "outages"
            ? "Outage Alerts"
            : type === "blinks"
            ? "Blink Alerts"
            : "Voltage Alerts"}
        </h2>

        {filtered.length > 0 && (
          <CSVLink
            data={exportData}
            filename={`voltage-alerts-${new Date().toISOString().split("T")[0]}.csv`}
            className="csv-button"
          >
            ⬇ Export CSV
          </CSVLink>
        )}

        {filtered.length === 0 ? (
          <NoDataMessage type={type} isEmpty={filtered.length === 0} />
        ) : (
          <table style={{ width: "100%", background: "#fff", borderRadius: "10px" }}>
            <thead>
              <tr>
                <th>Device ID</th>
                <th>Meter #</th>
                <th>Address</th>
                <th>L1-N (V)</th>
                <th>L2-N (V)</th>
                <th>L1-L2 (V)</th>
                <th>GPS Lat</th>
                <th>GPS Long</th>
                <th>Last Seen</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((d) => (
                <tr key={d.deviceId}>
                  <td>{d.deviceId}</td>
                  <td>{d.meterNumber || "-"}</td>
                  <td>{d.address || "-"}</td>
                  <td style={{ color: d.voltageL1 < minVoltage || d.voltageL1 > maxVoltage ? "red" : "inherit" }}>
                    {d.voltageL1 ?? "-"}
                  </td>
                  <td style={{ color: d.voltageL2 < minVoltage || d.voltageL2 > maxVoltage ? "red" : "inherit" }}>
                    {d.voltageL2 ?? "-"}
                  </td>
                  <td>{d.voltageLL ?? "-"}</td>
                  <td>{d.lat ?? "-"}</td>
                  <td>{d.lon ?? "-"}</td>
                  <td>{d.lastSeen ? new Date(d.lastSeen).toLocaleString() : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default FilteredView;
